<template>
  <div class="cooperation">
    <div class="main-container">
      <div class="top-container"></div>
      <div class="main">
        <div class="title">合作服务</div>
        <div class="desc">
          请填写表单，留下您的联系方式，我们将尽快和您沟通合作细节
        </div>
        <div class="form">
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-title required">姓名:</div>
              <input placeholder="请输入您的姓名" v-model="form.name" />
            </div>
            <div class="form-item">
              <div class="form-item-title required">联系电话:</div>
              <input placeholder="请输入您的联系电话" v-model="form.phone" />
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-title required">行业:</div>
              <input placeholder="请输入您的行业" v-model="form.industry" />
            </div>
            <div class="form-item">
              <div class="form-item-title required">主营:</div>
              <input
                placeholder="请输入您的主营项目"
                v-model="form.main_business"
              />
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
                <div class="form-item-title required">需求说明:</div>
                <textarea placeholder="请输入您的需求说明" v-model="form.introduction"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <button @click="onSubmit">提交</button>
      </div>
      <div class="desc">
        <p>如有更多需求内容，可联系衣创社区在线客服</p>
        <p>工作时间：9:00-18:00（工作日）</p>
      </div>
    </div>
  </div>
</template>
<script>
import {SubmitCooperation} from '@/api/social';
export default {
  data() {
    return {
      form: {
        name: "",
        phone: "",
        industry: "",
        main_business: "",
        introduction: "",
      },
    };
  },
  mounted() {},
  methods: {
    async onSubmit(){
        try{
            const {code,msg} = await SubmitCooperation(this.form);
            if(code>0) this.$layer.msg(msg);
            this.$layer.msg('提交成功,请耐心等待我们的联系');
            this.form = {
              name: "",
              phone: "",
              industry: "",
              main_business: "",
              introduction: "",
            }
            this.$router.push({name:'SubmitResult'});
        }catch(e){
            if(e.code > 0){
                this.$layer.msg(msg);
            }
        }
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./businesscooperation.scss";
</style>
